import { PageLink } from '../../../../../../assets/layout/core'
import { nameActionPageMain } from '../../info'

export const breadcrumbUpdate: PageLink[] = [
  {
    title: nameActionPageMain.name,
    path: nameActionPageMain.to,
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
